import React from "react";
import NavBar from "../../components/layout/NavBar";
import LandingFooter from "../../components/layout/LandingFooter";
import MinhasCorridasComponent from "../../components/corredor/MinhasCorridas";
import InscricaoService from "../../services/Inscricoes/InscricaoService";

class MinhasCorridas extends React.Component {
    constructor() {
        super();
        this.state = {
            counts: { qtd_corrida: 0, km_corridos: 0 },
            minhas_corridas: [],
        };

        this.inscricaoService = new InscricaoService();
    }

    componentDidMount() {
        const userId = sessionStorage.getItem('brv-user-id');
        if (userId) {
            this.inscricaoService.getCountCorridasUsuario(userId)
                .then(res => res.json())
                .then(data => this.setState({ counts: data }))
                .catch(err => console.log(err));

            this.inscricaoService.getInscricaoPerUsuario(userId)
                .then(res => res.json())
                .then(data => this.setState({ minhas_corridas: data }))
                .catch(err => console.log(err));
        }
    }

    render() {
        return (
            <div className="min-h-screen flex flex-col justify-between bg-urb-dark text-white">
                <header>
                    <NavBar />
                </header>
                <main className="flex-grow py-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
                    <MinhasCorridasComponent counts={this.state.counts} corridas={this.state.minhas_corridas} />
                </main>
                <LandingFooter />
            </div>
        );
    }
}

export default MinhasCorridas;